import React from 'react'
import styled from 'styled-components'
import { ReactComponent as CloseIcon } from '../assets/close.svg'

const Container = styled.div`
  text-align: right;
  margin-bottom: -40px;
  margin-top: 20px;
  margin-right: 20px;
`

const Button = styled.div`
  height: 16px;
  width: 16px;
  cursor: pointer;
  background-color: ${props => props.theme.colors.grey12};
  border-radius: 999px;

  &:hover {
    background-color: ${props => props.theme.colors.grey4};
  }
`

export default (props) => (
  <Container>
    <Button as={CloseIcon} {...props} />
  </Container>
)
